import { render } from "./WaveEdge.vue?vue&type=template&id=3887b400"
import script from "./WaveEdge.vue?vue&type=script&lang=js"
export * from "./WaveEdge.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__